export default __webpack_public_path__ + "static/media/CG.2bcdbb09.svg";